import { SaleTaxBreakdownController as controller } from './sale-tax-breakdown.controller'
import template from './sale-tax-breakdown.html'

export const SaleTaxBreakdownComponent = {
  controller,
  template,
}
